export const crossIcon = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none">
  <path d="M18 6L6 18M6 6l12 12"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"/>
</svg>`;
